import Application from "../../Application";
import { IAuthenticationService } from "../service/AuthenticationService";
import { ICredentialsService } from "../service/CredentialsService";

export default class LogoutInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private credentialsService: ICredentialsService;

  constructor({ application, authenticationService, credentialsService }) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.credentialsService = credentialsService;
  }

  execute() {
    try {
      this.authenticationService.logout();
      this.credentialsService.setIsLoggedIn(false);
      window.location.replace("/login");
    } catch (error: any) {
      console.log(error);
    }
  }
}
